import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { ScrollManager } from './components/ScrollManager';
import { Home } from './pages/Home';
import { ServiceArea } from './pages/ServiceArea';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkdx8txnjbnr">
      <div className="min-h-screen w-full overflow-x-hidden bg-vm-bg font-bornia text-white" data-id="element-1" data-mp="2rlyoa9krccgv">
        <ScrollManager data-id="element-2" data-mp="2mmvj8p4s268w" />
        <Navbar data-id="element-3" data-mp="2mnnhk7prei2v" />
        <Routes data-id="element-4" data-mp="2mjpyfm36lqiz">
          <Route path="/" element={<Home data-id="element-6" data-mp="31ayrk56alu0v" />} data-id="element-5" data-mp="31aqhel1k12td" />
          <Route path="/servicios/:slug" element={<ServiceArea data-id="element-8" data-mp="31cjp83nwlt2y" />} data-id="element-7" data-mp="31bia9o3romfy" />
          <Route path="*" element={<Home data-id="element-10" data-mp="2wj8cjlweui34" />} data-id="element-9" data-mp="2wjgptewg3peu" />
        </Routes>
        <Footer data-id="element-11" data-mp="2wi5n7ieqknpb" />
        <WhatsAppButton data-id="element-12" data-mp="28ufm24yk52fw" />
      </div>
    </BrowserRouter>;
}